/* eslint-disable no-unused-vars */
import * as React from 'react';
import { cn } from '@Utils/index';

export interface ICheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClassName?: string;
  value?: string | number;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultCheck?: boolean;
  mainWrapperStyles?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, ICheckboxProps>(
  (
    {
      className,
      placeholder,
      label,
      labelClassName,
      checked,
      onChange,
      defaultCheck,
      mainWrapperStyles,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={`naxatw-flex naxatw-items-center naxatw-justify-start naxatw-gap-2 ${mainWrapperStyles}`}
      >
        <input
          type="checkbox"
          className={cn(
            `naxatw-body-sm custom-checkbox naxatw-relative naxatw-h-4 naxatw-max-h-4 naxatw-min-h-4 naxatw-w-4 naxatw-min-w-4 naxatw-max-w-4`,
            className,
          )}
          defaultChecked={defaultCheck}
          checked={checked}
          onChange={onChange}
          ref={ref}
          {...rest}
        />

        {label ? (
          <label
            className={cn(
              ` naxatw-body-sm naxatw-text-matt-100`,
              labelClassName,
            )}
          >
            {label}
          </label>
        ) : null}
      </div>
    );
  },
);
Checkbox.displayName = 'Checkbox';

export default Checkbox;
